import React from 'react'
import HeaderLarge from 'components/HeaderLarge'

const MaintenanceMode: React.FC = () => {
  return <HeaderLarge title="メンテナンス中です" />
}

export default MaintenanceMode
